// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"e88c6e1e","90":"b75d4a1b","327":"a2dc7331","364":"26275f6a","394":"95bb175b","670":"6fe2ad6a","702":"2750394b","821":"0c3173a8","931":"2afcb1af"}[chunkId] + ".chunk.js";
};